import styled from '@emotion/styled';
import { globalHistory as history } from '@reach/router';
import React from 'react';

import withBaseLayout, { GlobalStyle } from './with-base-layout';

import ErrorBoundary from '../components/common/error-boundary';
import SEO from '../components/seo';
import PublicHeader from '../components/common/public-header';
import FooterComponent from '../components/common/footer';
import { LAYOUT_CONFIG } from '../constants';
import theme from '../theme';

interface LayoutProps {
  children: React.ReactNode;
  seoTitle: string;
  style?: string;
}

function PublicLayout({ children, seoTitle, style }: LayoutProps) {
  const {
    location: { pathname },
  } = history;
  // TODO: refactor to make a decision to include auth button from the section/component level.
  const excludeHeaderPaths = ['/form-preview', '/programs'];
  const excludeHeader = excludeHeaderPaths.some(path => new RegExp(`^${path}`).test(pathname));

  const Container = styled.div`
    position: relative;
    margin: 0 auto;
    max-width: ${LAYOUT_CONFIG.MAX_PAGE_WIDTH}px;
    ${style}
    @media (max-width: ${theme.screenMd}) {
      margin: 0 .75em;
    }
  `;

  return (
    <div>
      {GlobalStyle}
      {!excludeHeader && <PublicHeader />}
      <main>
        <Container>
          <SEO title={seoTitle} />
          <ErrorBoundary>{children}</ErrorBoundary>
        </Container>
      </main>
      <FooterComponent />
    </div>
  );
}

export default withBaseLayout(PublicLayout);
